<template>
    <!-- <v-container> -->
    <v-card style="border-radius: 8px;">
        <v-layout>
            <v-flex xs4 class="ml-5 mt-3">
                    <div>Response Id: 
                        <span style="color:#0084ff">{{cardId}}</span>
                    </div>
            </v-flex>
            <v-flex xs4 class="mt-3">
                <!-- <div class="title font-weight-regular"> Response messages </div> -->
            </v-flex>
            <v-flex xs4 class="mt-3">
                <v-card flat :href="boturl" target="_blank">
                    <div>Bot link: 
                        <span style="color:#0084ff">m.me/{{refid}}</span>
                    </div>
                </v-card>
            </v-flex>
        </v-layout>

        <v-layout>
            <v-flex xs4 class="scroll-y ml-3" style="max-height:350px">
                <v-card flat class="mt-3 ml-3">
                     <v-list>
                        <template v-for="(rmessage, index) in cMessages">
                            <v-list-tile                                
                                style="cursor: pointer;"
                                :key="index+'a'"
                                :color="rmessage.active ? 'primary' : ''"
                                >
                                <v-list-tile-content>
                                    <v-list-tile-title class="body-1 font-weight-regular" @click="expandTemplate(index)" @mouseover="openmenu(index)">{{ rmessage.name }}</v-list-tile-title>
                                    <v-list-tile-sub-title v-if="rmessage.active && rmessage.ref != ''" class="caption font-weight-regular">m.me/{{refid}}?ref={{ rmessage.ref }}</v-list-tile-sub-title>
                                    <v-list-tile-sub-title v-if="rmessage.active && rmessage.ref == ''" class="caption font-weight-regular">Ref not created</v-list-tile-sub-title>
                                </v-list-tile-content>
                                <v-list-tile-action v-if="hover1 == index">
                                    <v-card-actions @mouseleave="closemenu">
                                        <v-btn v-if="rmessage.name != 'Welcome Response' && rmessage.name != 'Default Response'" @click="editTemplateName(index,$event,'edittemplate')" flat icon color="grey">
                                                <v-icon small>edit</v-icon>
                                        </v-btn>    
                                        <v-btn v-if="rmessage.name != 'Welcome Response' && rmessage.name != 'Default Response'" @click="deleteTemplate(index)" flat icon color="grey">
                                                <v-icon small>delete</v-icon>
                                        </v-btn>
                                        <v-btn @click="expandTemplate(index)" flat icon color="grey lighten-1">
                                            <v-icon small>keyboard_arrow_right</v-icon>
                                        </v-btn>
                                    </v-card-actions>    
                                </v-list-tile-action>
                            </v-list-tile>                                   
                            <v-divider
                                v-if="index + 1 < cMessages.length"
                                :key="index+'b'"
                            ></v-divider>
                        </template>
                    </v-list>                    
                </v-card>
            </v-flex>
            <v-divider vertical></v-divider>
            <v-flex  xs7 class="scroll-y" style="max-height: 350px">
                <template v-for="(card, index) in cards">
                    <v-layout :key="index" @mouseleave="hidebuttons()">
                        <v-flex xs1 class="mt-2"> 
                            <v-layout>    
                            <v-btn
                                v-if="button1 == index && card.type == 'generic'"
                                class="mt-4"
                                small                                
                                color="grey"
                                fab
                                flat
                                @click="moveleft(index)"
                            >
                            <v-icon>chevron_left</v-icon>                                    
                            </v-btn>
                            </v-layout>                          
                        </v-flex>
                        <v-flex xs5 class="ma-0" @mouseover="showbuttons(index)"> 
                            <v-card v-if="card.type == 'delay'" flat style="border-radius: 8px;" class="ma-0 blue-grey lighten-5">
                                <v-card-title>
                                    <v-slider
                                        class="mt-3 mb-0"
                                        v-model="card.delay"
                                        prepend-icon="alarm"
                                        :thumb-size="24"
                                        thumb-label="always"
                                        :max="20"
                                        color="blue lighten-1"
                                        @input="updateDelay(index,card.delay)"
                                    ></v-slider> 
                                </v-card-title>
                            </v-card>                           
                            <v-card v-if="card.type == 'text'" flat style="border-radius: 8px;" class="ma-0 blue-grey lighten-5">
                                <v-card-title  class="body-1 font-weight-regular mt-3"> {{card.message.text}}</v-card-title>
                            </v-card>
                            <v-card v-if="card.type == 'integration'" flat style="border-radius: 8px;" class="ma-0 blue-grey lighten-5">
                                <v-card-title  class="body-1 font-weight-regular mt-3"><b>{{card.integration_details.integration_type}} Integration:</b> {{card.integration_details.short_note}}</v-card-title>
                            </v-card>
                            <v-card v-if="card.type == 'userinput'" flat style="border-radius: 8px;" class="ma-0 blue-grey lighten-5">
                                <v-card-title  class="body-1 font-weight-regular mt-3"> <b>Request User:</b> {{card.message.text}} <b>Save to Variable:</b> {{card.savetovar}}</v-card-title>
                                <template v-for="(userinput_qr,qrindex) in card.message.quick_replies" >
                                    <v-chip :key="qrindex" small outline color="primary">
                                        <div v-if="userinput_qr.content_type == 'user_phone_number'">User Phone number</div>
                                        <div v-if="userinput_qr.content_type == 'user_email'">User Email</div>
                                        <div v-if="userinput_qr.content_type == 'text'">{{userinput_qr.title}}</div>
                                    </v-chip>
                                </template>
                                <v-card-title  class="caption grey--text mt-0"> **Bot will wait only 10 minutes for User input</v-card-title>
                            </v-card>
                            <v-card v-if="card.type == 'setvar'" flat style="border-radius: 8px;" class="ma-0 blue-grey lighten-5">
                                <v-card-title  class="body-1 font-weight-regular mt-3"> <b>Variable:</b> {{card.setvar}} <b>Set Value:</b> {{card.setval}}</v-card-title>
                            </v-card>
                            <v-card v-if="card.type == 'button'" flat style="border-radius: 8px;" class="ma-0 blue-grey lighten-5">
                                <v-card-title class="body-1 font-weight-regular mt-3"> {{card.message.attachment.payload.text}}</v-card-title>
                                <v-flex>
                                    <v-tooltip bottom v-for="(button,tbindex) in card.message.attachment.payload.buttons" :key="tbindex">
                                        <template v-slot:activator="{ on }">
                                        <v-btn small depressed block round color="white" v-on="on">{{button.title}}</v-btn>
                                        </template>
                                    <span v-if="button.type == 'phone_number'">Phone number: {{button.payload}}</span>
                                    <span v-if="button.type == 'postback'">Link to response: {{button.payload}}</span>
                                    <span v-if="button.type == 'web_url'">url: {{button.url}} <br> webview height: {{button.webview_height_ratio}}</span>
                                    </v-tooltip>
                                </v-flex> 
                            </v-card>
                            <v-card v-if="card.type == 'image' || card.type == 'video' || card.type == 'audio' || card.type =='file'" flat style="border-radius: 8px;" class="ma-0 blue-grey lighten-5">
                                <v-card-title v-if="card.uploadtype == 'asset'" class="body-1 font-weight-regular mt-3">
                                 <span>Message type: {{card.type}}<br>Assest: {{card.name}}</span> 
                                </v-card-title>
                                <v-card-title v-if="card.uploadtype == 'url' && (card.type == 'video'|| card.type == 'audio' || card.type == 'file')" class="body-1 font-weight-regular mt-3">
                                 <span class="text-truncate">Message type: {{card.type}}<br>URL: {{card.message.attachment.payload.url}}</span> 
                                </v-card-title>
                                <v-img
                                    v-if="card.uploadtype == 'url' && card.type == 'image'"
                                    :src="card.message.attachment.payload.url"
                                >
                                </v-img>
                            </v-card>
                            <v-card v-if="card.type == 'media'" flat style="border-radius: 8px;" class="ma-0 blue-grey lighten-5">
                                <v-card-title v-if="card.uploadtype == 'asset'" class="body-1 font-weight-regular mt-3">
                                 <span>Message type: {{card.mediatype}}<br>Assest: {{card.name}}</span> 
                                </v-card-title>
                                <v-card-title v-if="card.uploadtype == 'url' && (card.mediatype == 'video' || card.mediatype == 'image')" class="body-1 font-weight-regular mt-3">
                                 <span class="text-truncate">Message type: {{card.mediatype}}<br>URL: {{card.message.attachment.payload.elements[0].url}}</span> 
                                </v-card-title>
                                <v-flex v-if="card.button=='Yes'">
                                    <v-tooltip bottom v-for="(button,mindex) in card.message.attachment.payload.elements[0].buttons" :key="mindex">
                                        <template v-slot:activator="{ on }">
                                        <v-btn v-if="button.type != 'element_share'" small depressed block round color="white" v-on="on">{{button.title}}</v-btn>
                                        <v-btn v-if="button.type == 'element_share'" small depressed block round color="white" v-on="on">Share</v-btn>
                                        </template>
                                    <span v-if="button.type == 'phone_number'">Phone number: {{button.payload}}</span>
                                    <span v-if="button.type == 'element_share'">Sharble button</span>
                                    <span v-if="button.type == 'postback'">Link to response: {{button.payload}}</span>
                                    <span v-if="button.type == 'web_url'">url: {{button.url}} <br> webview height: {{button.webview_height_ratio}}</span>
                                    </v-tooltip>
                                </v-flex>
                            </v-card>
                            <v-card v-if="card.type == 'generic'" flat style="border-radius: 8px;" class="ma-0 blue-grey lighten-5">
                                <template v-for="(gallerycard, cindex) in card.message.attachment.payload.elements">
                                    <v-card v-if="card.currentelement == cindex" :key="cindex"  flat style="border-radius: 8px;" class="ma-0 blue-grey lighten-5">                                    
                                        <v-img
                                            :src="gallerycard.image_url"
                                            :aspect-ratio="card.message.attachment.payload.image_aspect_ratio == 'square' ? '1':'1.91'"
                                        >
                                        </v-img>
                                        <div class="body-1 font-weight-regular ml-2 mr-2 mt-2">{{gallerycard.title}}</div> 
                                        <div class="caption font-weight-regular grey--text ml-2 mr-2">{{gallerycard.subtitle}}</div>
                                        <div class="caption font-weight-regular grey--text ml-2 mr-2" v-if="card.imageaction[cindex]">{{gallerycard.default_action.url}}</div>
                                        <v-flex>
                                            <v-tooltip bottom v-for="(button,bindex) in card.message.attachment.payload.elements[cindex].buttons" :key="bindex">
                                                <template v-slot:activator="{ on }">
                                                <v-btn v-if="button.type != 'element_share'" small depressed block round color="white" v-on="on">{{button.title}}</v-btn>
                                                <v-btn v-else-if="button.type == 'element_share'" small depressed block round color="white" v-on="on">Share</v-btn>
                                                </template>
                                            <span v-if="button.type == 'phone_number'">Phone number: {{button.payload}}</span>
                                            <span v-if="button.type == 'element_share'">Sharble button</span>
                                            <span v-if="button.type == 'postback'">Link to response: {{button.payload}}</span>
                                            <span v-if="button.type == 'web_url'">url: {{button.url}} <br> webview height: {{button.webview_height_ratio}}</span>
                                            </v-tooltip>
                                        </v-flex>                                         
                                    </v-card>
                                </template>                             
                            </v-card>
                            <!-- <v-card v-if="card.type == 'list'" flat style="border-radius: 8px;" class="ma-0 mt-4 blue-grey lighten-5">
                                <template v-for="(listitem, listindex) in card.message.attachment.payload.elements">
                                <div v-if="card.message.attachment.payload.top_element_style == 'large' && listindex == 0 " :key="listindex+'a'" row>
                                    <v-card flat style="border-radius: 8px;">
                                        <v-tooltip  bottom>
                                            <template v-slot:activator="{ on }">
                                        <v-img
                                            v-on="on"
                                            :src="listitem.image_url" 
                                            aspect-ratio="1.91"
                                        >
                                        <div class="ml-2 mt-3"> 
                                        <div class="caption font-weight-bold text-truncate ml-2">{{listitem.title}}</div>
                                        <div class="caption text-truncate ml-2">{{listitem.subtitle}}</div>
                                        <div v-if="card.listbuttonstatus[listindex] == true">
                                            <v-tooltip  bottom>
                                            <template v-slot:activator="{ on }">
                                                <v-chip v-on="on" small outline color="primary">{{listitem.buttons[0].type =='element_share' ? 'Share':listitem.buttons[0].title}}</v-chip>
                                            </template>
                                            <span v-if="listitem.buttons[0].type == 'phone_number'">Phone number: {{listitem.buttons[0].payload}}</span>
                                            <span v-if="listitem.buttons[0].type == 'element_share'">Sharble button</span>
                                            <span v-if="listitem.buttons[0].type == 'postback'">Link to response: {{listitem.buttons[0].payload}}</span>
                                            <span v-if="listitem.buttons[0].type == 'web_url' && card.extentionstatus.listbutton[listindex] == true">url: {{listitem.buttons[0].url}} <br> webview height: {{listitem.buttons[0].webview_height_ratio}}  <br> Messenger extension: {{listitem.buttons[0].messenger_extensions}}</span>
                                            <span v-if="listitem.buttons[0].type == 'web_url' && card.extentionstatus.listbutton[listindex] == false ">url: {{listitem.buttons[0].url}} <br> webview height: {{listitem.buttons[0].webview_height_ratio}}  <br> Messenger extension: false</span>
                                        </v-tooltip>
                                        </div>
                                        </div>
                                        </v-img>
                                        </template>
                                            <span v-if="card.imageaction[listindex] == true && card.extentionstatus.imageaction[listindex] == true">url: {{listitem.default_action.url}} <br> webview height: {{listitem.default_action.webview_height_ratio}}  <br> Messenger extension: {{listitem.default_action.messenger_extensions}}</span>
                                            <span v-if="card.imageaction[listindex] == true && card.extentionstatus.imageaction[listindex] == false">url: {{listitem.default_action}} <br> webview height: {{listitem.default_action.webview_height_ratio}}  <br> Messenger extension: false</span>
                                            <span v-if="card.imageaction[listindex] == false">Click action disabled</span>
                                        </v-tooltip>
                                    </v-card>
                                </div>
                                <v-layout v-if="card.message.attachment.payload.top_element_style == 'large' && listindex > 0 " :key="listindex+'b'" row>
                                    <v-flex xs7>
                                        <div class="ml-2"> 
                                        <div class="caption font-weight-bold text-truncate ml-2">{{listitem.title}}</div>
                                        <div class="caption text-truncate ml-2">{{listitem.subtitle}}</div>
                                        <div v-if="card.listbuttonstatus[listindex] == true">
                                            <v-tooltip  bottom>
                                            <template v-slot:activator="{ on }">
                                                <v-chip v-on="on" small outline color="primary">{{listitem.buttons[0].type =='element_share' ? 'Share':listitem.buttons[0].title}}</v-chip>
                                            </template>
                                            <span v-if="listitem.buttons[0].type == 'phone_number'">Phone number: {{listitem.buttons[0].payload}}</span>
                                            <span v-if="listitem.buttons[0].type == 'element_share'">Sharble button</span>
                                            <span v-if="listitem.buttons[0].type == 'postback'">Link to response: {{listitem.buttons[0].payload}}</span>
                                            <span v-if="listitem.buttons[0].type == 'web_url' && card.extentionstatus.listbutton[listindex] == true">url: {{listitem.buttons[0].url}} <br> webview height: {{listitem.buttons[0].webview_height_ratio}}  <br> Messenger extension: {{listitem.buttons[0].messenger_extensions}}</span>
                                            <span v-if="listitem.buttons[0].type == 'web_url' && card.extentionstatus.listbutton[listindex] == false ">url: {{listitem.buttons[0].url}} <br> webview height: {{listitem.buttons[0].webview_height_ratio}}  <br> Messenger extension: false</span>
                                        </v-tooltip>
                                        </div>
                                        </div>
                                    </v-flex>
                                    <v-flex v-if="card.imageurlstatus[listindex] == true" xs5>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                        <v-img
                                            v-on="on"
                                            style="border-radius: 8px;"
                                            class="mr-2"
                                            :src="listitem.image_url" 
                                            aspect-ratio="1"
                                        ></v-img>
                                        </template>
                                        <span v-if="card.imageaction[listindex] == true && card.extentionstatus.imageaction[listindex] == true">url: {{listitem.default_action.url}} <br> webview height: {{listitem.default_action.webview_height_ratio}}  <br> Messenger extension: {{listitem.default_action.messenger_extensions}}</span>
                                        <span v-if="card.imageaction[listindex] == true && card.extentionstatus.imageaction[listindex] == false">url: {{listitem.default_action}} <br> webview height: {{listitem.default_action.webview_height_ratio}}  <br> Messenger extension: false</span>
                                        <span v-if="card.imageaction[listindex] == false">Click action disabled</span>
                                    </v-tooltip>
                                    </v-flex>
                                </v-layout>
                                <v-layout v-if="card.message.attachment.payload.top_element_style == 'compact'" :key="listindex+'c'" row>
                                    <v-flex xs7>
                                        <div class="ml-2"> 
                                        <div class="caption font-weight-bold text-truncate ml-2">{{listitem.title}}</div>
                                        <div class="caption text-truncate ml-2">{{listitem.subtitle}}</div>
                                        <div v-if="card.listbuttonstatus[listindex] == true">
                                            <v-tooltip  bottom>
                                            <template v-slot:activator="{ on }">
                                                <v-chip v-on="on" small outline color="primary">{{listitem.buttons[0].type =='element_share' ? 'Share':listitem.buttons[0].title}}</v-chip>
                                            </template>
                                            <span v-if="listitem.buttons[0].type == 'phone_number'">Phone number: {{listitem.buttons[0].payload}}</span>
                                            <span v-if="listitem.buttons[0].type == 'element_share'">Sharble button</span>
                                            <span v-if="listitem.buttons[0].type == 'postback'">Link to response: {{listitem.buttons[0].payload}}</span>
                                            <span v-if="listitem.buttons[0].type == 'web_url' && card.extentionstatus.listbutton[listindex] == true">url: {{listitem.buttons[0].url}} <br> webview height: {{listitem.buttons[0].webview_height_ratio}}  <br> Messenger extension: {{listitem.buttons[0].messenger_extensions}}</span>
                                            <span v-if="listitem.buttons[0].type == 'web_url' && card.extentionstatus.listbutton[listindex] == false ">url: {{listitem.buttons[0].url}} <br> webview height: {{listitem.buttons[0].webview_height_ratio}}  <br> Messenger extension: false</span>
                                        </v-tooltip>
                                        </div>
                                        </div>
                                    </v-flex>
                                    <v-flex v-if="card.imageurlstatus[listindex] == true" xs5>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                        <v-img
                                            v-on="on"
                                            style="border-radius: 8px;"
                                            class="mr-2"
                                            :src="listitem.image_url" 
                                            aspect-ratio="1"
                                        ></v-img>
                                        </template>
                                        <span v-if="card.imageaction[listindex] == true && card.extentionstatus.imageaction[listindex] == true">url: {{listitem.default_action.url}} <br> webview height: {{listitem.default_action.webview_height_ratio}}  <br> Messenger extension: {{listitem.default_action.messenger_extensions}}</span>
                                        <span v-if="card.imageaction[listindex] == true && card.extentionstatus.imageaction[listindex] == false">url: {{listitem.default_action}} <br> webview height: {{listitem.default_action.webview_height_ratio}}  <br> Messenger extension: false</span>
                                        <span v-if="card.imageaction[listindex] == false">Click action disabled</span>
                                    </v-tooltip>
                                    </v-flex>
                                </v-layout>
                                <v-divider v-if="card.message.attachment.payload.elements.length == listindex +1 && card.bottomlistbuttonstatus == true" :key="listindex+'d'" light></v-divider>
                                <v-divider v-if="listindex +1 < card.message.attachment.payload.elements.length" :key="listindex+'e'" light></v-divider>
                                </template>
                                <div v-if="card.bottomlistbuttonstatus == true">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <div v-on="on" class="ma-1 text-xs-center primary--text">{{card.message.attachment.payload.buttons[0].type == 'element_share' ? 'Share':card.message.attachment.payload.buttons[0].title}}</div>
                                    </template>
                                    <span v-if="card.message.attachment.payload.buttons[0].type == 'phone_number'">Phone number: {{card.message.attachment.payload.buttons[0].payload}}</span>
                                    <span v-if="card.message.attachment.payload.buttons[0].type == 'element_share'">Sharble button</span>
                                    <span v-if="card.message.attachment.payload.buttons[0].type == 'postback'">Link to response: {{card.message.attachment.payload.buttons[0].payload}}</span>
                                    <span v-if="card.message.attachment.payload.buttons[0].type == 'web_url' && card.extentionstatus.bottombutton == true">url: {{card.message.attachment.payload.buttons[0].url}} <br> webview height: {{card.message.attachment.payload.buttons[0].webview_height_ratio}}  <br> Messenger extension: {{card.message.attachment.payload.buttons[0].messenger_extensions}}</span>
                                    <span v-if="card.message.attachment.payload.buttons[0].type == 'web_url' && card.extentionstatus.bottombutton == false">url: {{card.message.attachment.payload.buttons[0].url}} <br> webview height: {{card.message.attachment.payload.buttons[0].webview_height_ratio}}  <br> Messenger extension: false</span>
                                </v-tooltip>
                                </div>
                            </v-card> -->
                        </v-flex>
                        <v-flex xs2 class="mt-2">
                            <v-layout>
                            <span v-if="button1 == index && card.type == 'generic'">{{card.currentelement+1+'/'+card.elementscount}}</span>
                            <v-btn
                                v-if="button1 == index && card.type == 'generic'"
                                class="mt-4"
                                small
                                color="grey"
                                fab
                                flat                                
                                @click="moveright(index)"
                            >
                            <v-icon>chevron_right</v-icon>                                    
                            </v-btn>
                            <v-btn
                                v-if="button1 == index && card.type != 'delay'"
                                class="mt-4"
                                small
                                color="grey"
                                fab
                                flat
                                @click="editcard($event,card.type,index)"
                            >
                            <v-icon>edit</v-icon>                                    
                            </v-btn>
                            <v-btn
                                v-if="button1 == index"
                                class="mt-4"
                                small
                                color="grey"
                                fab
                                flat
                                @click="deleteCard(index)"
                            >
                            <v-icon>delete</v-icon>                                    
                            </v-btn>
                            <v-btn
                                v-if="button1 == index && index != 0"
                                class="mt-4"
                                small
                                color="grey"
                                fab
                                flat
                                @click="moveup(index)"
                            >
                            <v-icon>keyboard_arrow_up</v-icon>                                    
                            </v-btn>
                            <v-btn
                                v-if="button1 == index && index != cards.length-1"
                                class="mt-4"
                                small
                                color="grey"
                                fab
                                flat
                                @click="movedown(index)"
                            >
                            <v-icon>keyboard_arrow_down</v-icon>                                    
                            </v-btn>
                            </v-layout>                            
                        </v-flex>
                    </v-layout>
                </template>
                <v-card @mouseleave="hideqrbuttons" v-if="cards.length != 0" class="mt-4" flat style="border-radius: 8px;">
                    <template v-for="(quickreply,qrindex) in cquickreplies" >
                        <v-chip  @mouseover="showqrbuttons(qrindex)" :key="qrindex" small color="blue-grey lighten-5">
                            <div v-if="quickreply.content_type == 'user_phone_number'">User Phone number</div>
                            <div v-if="quickreply.content_type == 'user_email'">User Email</div>
                            <div v-if="quickreply.content_type == 'location'">Send location</div>
                            <div v-if="quickreply.content_type == 'text'">{{quickreply.title}}</div>
                            <v-btn class="mr-0" v-if="qrindex == quickreplyindex" flat icon small @click="editquickreply($event,qrindex)"><v-icon small color="grey">edit</v-icon></v-btn>
                            <v-btn class="mr-0" v-if="qrindex == quickreplyindex" flat icon small @click="deletequickreply(qrindex)"><v-icon small color="grey">delete</v-icon></v-btn>
                        </v-chip>
                    </template>
                    <v-btn v-if="cquickreplies.length <= 10" round flat outline small color="primary" @click="selectCardType($event,'quickreply')">+ Create Quick reply</v-btn>
                </v-card>
            </v-flex>
        </v-layout>        
        <v-layout>
            <v-flex xs4 class="mt-3 ml-3">
                <!-- <div class="mt-3">.</div> -->
                <v-card class="mt-4" flat style="border-radius: 8px;">
                        <v-card-actions class="blue lighten-5 justify-space-between"> 
                             <v-btn @click="selectCardType($event,'template')" flat block color="primary"> + Create response</v-btn>
                        </v-card-actions>
                </v-card> 
            </v-flex>
            <v-flex xs8 class="ma-3">
                <!-- <div class="title font-weight-regular mt-3"> Create message</div> -->
                     <v-card class="mt-4 blue lighten-5" flat style="border-radius: 8px;">
                        <v-card-actions v-if="templateIndex != null" class="justify-space-between">
                                <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                <v-btn icon @click="addDelay('delay')" v-on="on">
                                    <v-icon>alarm</v-icon>
                                </v-btn>
                                </template>
                                <span>Set typing delay</span>
                                </v-tooltip>          
                                <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                <v-btn icon @click="selectCardType($event,'text')" v-on="on">
                                    <v-icon>notes</v-icon>
                                </v-btn>
                                </template>
                                <span>Text</span>
                                </v-tooltip>
                                <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                <v-btn icon @click="selectCardType($event,'button')" v-on="on">
                                    <v-icon>short_text</v-icon>
                                </v-btn>
                                </template>
                                <span>Text with Buttons</span>
                                </v-tooltip>
                                <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                <v-btn icon @click="selectCardType($event,'image')" v-on="on">
                                    <v-icon>photo</v-icon>
                                </v-btn>
                                </template>
                                <span>Image</span>
                                </v-tooltip>
                                <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                <v-btn @click="selectCardType($event,'generic')" icon v-on="on">
                                    <v-icon>photo_library</v-icon>
                                </v-btn>
                                </template>
                                <span>Gallery</span>
                                </v-tooltip>
                                <!-- <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                <v-btn @click="selectCardType($event,'list')" icon v-on="on">
                                    <v-icon>list</v-icon>
                                </v-btn>
                                </template>
                                <span>List</span>
                                </v-tooltip> -->
                                <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                <v-btn icon @click="selectCardType($event,'audio')" v-on="on">
                                    <v-icon>audiotrack</v-icon>
                                </v-btn>
                                </template>
                                <span>Audio</span>
                                </v-tooltip>
                                <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                <v-btn icon @click="selectCardType($event,'video')" v-on="on">
                                    <v-icon>videocam</v-icon>
                                </v-btn>
                                </template>
                                <span>Video</span>
                                </v-tooltip>
                                <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                <v-btn icon @click="selectCardType($event,'file')" v-on="on">
                                    <v-icon>description</v-icon>
                                </v-btn>
                                </template>
                                <span>File</span>
                                </v-tooltip>                          
                                <!-- <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                <v-btn icon v-on="on">
                                    <v-icon>link</v-icon>
                                </v-btn>
                                </template>
                                <span>link to another flow</span>
                                </v-tooltip>              -->
                                <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                <v-btn icon @click="selectCardType($event,'userinput')" v-on="on">
                                    <v-icon>input</v-icon>
                                </v-btn>
                                </template>
                                <span>User Input</span>
                                </v-tooltip>
                                <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                <v-btn icon @click="selectCardType($event,'setvar')" v-on="on">
                                    <v-icon>all_inclusive</v-icon>
                                </v-btn>
                                </template>
                                <span>Set Variable</span>
                                </v-tooltip>
                                <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                <v-btn icon @click="selectCardType($event,'integrations')" v-on="on">
                                    <v-icon small>fa-asterisk</v-icon>
                                </v-btn>
                                </template>
                                <span>Set Integraton</span>
                                </v-tooltip>             
                        </v-card-actions>
                    </v-card>
            </v-flex>
        </v-layout>
        <v-menu v-model="bcastmenu"
                :close-on-click = "false"
                :position-x="x"
                :position-y="y"
                offset-x
                :close-on-content-click="false"
                :nudge-width="600">
            <v-card>
                <createtemplate v-if="cardtype == 'template'"></createtemplate>
                <edittemplate v-if="cardtype == 'edittemplate'"></edittemplate>
                <createtext  v-if="cardtype == 'text'"></createtext>
                <edittext  v-if="cardtype == 'edit-text'"></edittext>
                <createbutton v-if="cardtype == 'button'"></createbutton>
                <editbutton v-bind:editbutton="editbutton" v-if="cardtype == 'edit-button'"></editbutton>
                <creategallery v-if="cardtype == 'generic'"></creategallery>
                <editgallery v-bind:editgallery="editgallery" v-if="cardtype == 'edit-generic'"></editgallery>
                <createlist v-if="cardtype == 'list'"></createlist>
                <editlist v-bind:editlist="editlist" v-bind:editlistbutton="editlistbutton"  v-if="cardtype == 'edit-list'"></editlist>
                <createquickreply v-if="cardtype == 'quickreply'"></createquickreply>
                <editquickreply v-bind:editqreply="editqreply" v-if="cardtype == 'edit-quickreply'"></editquickreply>
                <createmedia v-bind:mediatype="cardtype" v-if="cardtype == 'image'"></createmedia>
                <editmedia v-bind:mediatype="editmedia" v-if="cardtype == 'edit-image'"></editmedia>
                <createmedia v-bind:mediatype="cardtype" v-if="cardtype == 'video'"></createmedia>
                <editmedia v-bind:mediatype="editmedia" v-if="cardtype == 'edit-video'"></editmedia>
                <createmedia v-bind:mediatype="cardtype" v-if="cardtype == 'audio'"></createmedia>
                <editmedia v-bind:mediatype="editmedia" v-if="cardtype == 'edit-audio'"></editmedia>
                <createmedia v-bind:mediatype="cardtype" v-if="cardtype == 'file'"></createmedia>
                <editmedia v-bind:mediatype="editmedia" v-if="cardtype == 'edit-file'"></editmedia>
                <userinput v-if="cardtype == 'userinput'"></userinput>
                <edituserinput  v-if="cardtype == 'edit-userinput'"></edituserinput>
                <setvar v-if="cardtype == 'setvar'"></setvar>
                <editsetvar  v-if="cardtype == 'edit-setvar'"></editsetvar>
                <integrations  v-if="cardtype == 'integrations'"></integrations>
                <editintegration v-bind:editintegrations="editintegrations" v-if="cardtype == 'edit-integration'"></editintegration>
            </v-card>
        </v-menu>   
    </v-card>
    <!-- </v-container> -->
</template>

<script>
import createtemplate from './Response-message-createname.vue'
import edittemplate from './Response-message-edittemplate.vue'
import createtext from './Response-message-createtext.vue'
import edittext from './Response-message-createtext-edit.vue'
import createbutton from './Response-message-createbutton.vue'
import editbutton from './Response-message-createbutton-edit.vue'
import creategallery from './Response-message-creategallery.vue'
import editgallery from './Response-message-creategallery-edit.vue'
import createlist from './Response-message-createlist.vue'
import editlist from './Response-message-createlist-edit.vue'
import createquickreply from './Response-message-createquickreply.vue'
import editquickreply from './Response-message-createquickreply-edit.vue'
import createmedia from './Response-message-createmedia.vue'
import editmedia from './Response-message-createmedia-edit.vue'
import userinput from './Response-message-userinput.vue'
import edituserinput from './Response-message-userinput-edit.vue'
import setvar from './Response-message-setvar.vue'
import editsetvar from './Response-message-setvar-edit.vue'
import integrations from './Response-message-createIntegrations.vue'
import editintegration from './Response-message-createIntegrations-edit.vue'
import Vue from 'vue'
export default {
    components:{
        createtext,
        edittext,
        createbutton,
        editbutton,
        creategallery,
        editgallery,
        createlist,
        editlist,
        createtemplate,
        edittemplate,
        createquickreply,
        editquickreply,
        createmedia,
        editmedia,
        userinput,
        edituserinput,
        setvar,
        editsetvar,
        integrations,
        editintegration
    },
    data(){
        return{
            cardtype:null,
            editmedia: {
                "mediatype":null,
                "uploadtype":null,
                "url":null,
                "attachment_id":null,
                "button":'No',
                "buttontype":null,
                "buttonpayloadph":null,
                "buttonpayloadpb":null,
                "buttonwebview_height_ratio":"tall",
                "buttonurl":null,
                "buttontitle":null
                },
                editqreply:{},
                editgallery:[],
                editbutton:{
                    "buttons":[
                            {"label":"First Button","active":false,"title":null,"type":null,"url":null,"webview_height_ratio":"tall","payload":null,"response":null},
                            {"label":"Second Button","active":false,"title":null,"type":null,"url":null,"webview_height_ratio":"tall","payload":null,"response":null},
                            {"label":"Third Button","active":false,"title":null,"type":null,"url":null,"webview_height_ratio":"tall","payload":null,"response":null}
                        ],
                        "text":null
                },
                editlist:[],
                editlistbutton:{},
                editintegrations:{},
            inputtype:null,
            readcardtype:[],
            x:0,
            y:0,
            expand:false,
            hover1:null,
            button1:false,
            gallerycardindex:0,
            totalgallerycards:null,
            delay:2,
            quickreplyindex:null,
            mediatype:null,
            boturl:null,
            cardId:null
        }
    },
    methods:{
        selectCardType(event,type){
            event.preventDefault()
            this.x = event.clientX
            this.y = event.clientY
            this.cardtype = type
            let status = true
            this.$store.dispatch('aresponsemenuStatusChange',status)
        },
        editcard(event,type,index){
            let card = this.cards[index]
            console.log(card)
            this.$store.dispatch('aresponseEditor',{index, card})
            event.preventDefault()
            this.x = event.clientX
            this.y = event.clientY
            this.cardtype = 'edit-'+type
            console.log(this.cardtype)
            if (this.cardtype == 'edit-image' || this.cardtype == 'edit-video' || this.cardtype == 'edit-audio' || this.cardtype == 'edit-file')
            {
                this.editmedia.mediatype = this.cardtype
                console.log( this.editmedia.mediatype)
                this.editmedia.button = 'No'
                if (card.uploadtype == 'asset'){
                this.editmedia.uploadtype = "Asset"
                let assets = this.$store.state.assets
                for (let asset in assets){
                    console.log(asset)
                    if(assets[asset].id == card.message.attachment.payload.attachment_id){
                        this.editmedia.attachment_id  = {"nickname":assets[asset].nickname,"id":card.message.attachment.payload.attachment_id,"type":assets[asset].type}
                        console.log(this.editmedia.attachment_id) 
                    }
                }
                }
                else{
                this.editmedia.uploadtype = "URL"
                this.editmedia.url = card.message.attachment.payload.url
                }
                console.log(this.editmedia)
            }
            else if(this.cardtype == 'edit-media')
            {
                   this.editmedia.mediatype = 'edit-'+card.mediatype
                   this.cardtype = 'edit-'+card.mediatype
                    console.log("enter")
                    this.editmedia.button = 'Yes'
                    this.editmedia.buttontype = card.message.attachment.payload.elements[0].buttons[0].type
                     if(this.editmedia.buttontype == 'phone_number'){
                        this.editmedia.buttontitle = card.message.attachment.payload.elements[0].buttons[0].title
                        this.editmedia.buttonpayloadph = card.message.attachment.payload.elements[0].buttons[0].payload
                        this.editmedia.buttonwebview_height_ratio = 'tall'
                    }
                    else if(this.editmedia.buttontype == 'postback'){
                        this.editmedia.buttontitle = card.message.attachment.payload.elements[0].buttons[0].title
                        this.editmedia.buttonpayloadpb = card.message.attachment.payload.elements[0].buttons[0].payload
                    }
                    else if(this.editmedia.buttontype == 'web_url'){
                        this.editmedia.buttontitle = card.message.attachment.payload.elements[0].buttons[0].title
                        this.editmedia.buttonwebview_height_ratio = card.message.attachment.payload.elements[0].buttons[0].webview_height_ratio
                        this.editmedia.buttonurl = card.message.attachment.payload.elements[0].buttons[0].url              
                    }
                    if (card.uploadtype == 'asset'){
                    this.editmedia.uploadtype = "Asset"
                    let assets = this.$store.state.assets
                    for (let asset in assets){
                        console.log(asset)
                        if(assets[asset].id == card.message.attachment.payload.elements[0].attachment_id){
                            this.editmedia.attachment_id  = {"nickname":assets[asset].nickname,"id":card.message.attachment.payload.elements[0].attachment_id,"type":assets[asset].type}
                            console.log(this.editmedia.attachment_id) 
                        }
                    }
                    }
                    else{
                    this.editmedia.uploadtype = "Facebook URL"
                    this.editmedia.url = card.message.attachment.payload.elements[0].url         
                    }
                    
            }
            else if(this.cardtype == 'edit-button')
            {
                this.editbutton = {
                    "buttons":[
                            {"label":"First Button","active":false,"title":null,"type":null,"url":null,"webview_height_ratio":"tall","payload":null,"response":null},
                            {"label":"Second Button","active":false,"title":null,"type":null,"url":null,"webview_height_ratio":"tall","payload":null,"response":null},
                            {"label":"Third Button","active":false,"title":null,"type":null,"url":null,"webview_height_ratio":"tall","payload":null,"response":null}
                        ],
                        "text":null
                }
                this.editbutton.text = card.message.attachment.payload.text
                for (let button = 0; button < 3; button++){
                    if(card.message.attachment.payload.buttons[button] != undefined || card.message.attachment.payload.buttons[button] != null){
                        this.editbutton.buttons[button].active = true 
                        this.editbutton.buttons[button].type =  card.message.attachment.payload.buttons[button].type
                        if(card.message.attachment.payload.buttons[button].type == 'postback'){
                            console.log(card.message.attachment.payload.buttons[button].payload)
                            let obj = this.$store.state.responses
                            let respname
                            Object.keys(obj).forEach(function(key) {
                            if (obj[key].id == card.message.attachment.payload.buttons[button].payload) {
                                respname = obj[key].name
                            }
                            });
                            this.editbutton.buttons[button].title = card.message.attachment.payload.buttons[button].title
                            this.editbutton.buttons[button].response = {"name":respname,"id":card.message.attachment.payload.buttons[button].payload}                
                        }
                        else if(card.message.attachment.payload.buttons[button].type == 'phone_number'){
                            this.editbutton.buttons[button].title = card.message.attachment.payload.buttons[button].title
                            this.editbutton.buttons[button].payload = card.message.attachment.payload.buttons[button].payload
                        }
                        else if(card.message.attachment.payload.buttons[button].type == 'web_url'){
                            this.editbutton.buttons[button].title = card.message.attachment.payload.buttons[button].title
                            this.editbutton.buttons[button].url = card.message.attachment.payload.buttons[button].url
                            this.editbutton.buttons[button].webview_height_ratio = card.message.attachment.payload.buttons[button].webview_height_ratio
                        }            
                    }
                }

            }
            else if(this.cardtype == 'edit-generic')
            { 
                this.editgallery = []
                console.log(card)
                console.log(card.message.attachment.payload.elements)
                for(let element = 0; element < card.elementscount; element++)
                    {   
                        let gallery = {}
                        gallery.buttons = []
                        gallery.active = true
                        gallery.file = null
                        gallery.title = card.message.attachment.payload.elements[element].title
                        gallery.image_url = card.message.attachment.payload.elements[element].image_url
                        if(card.message.attachment.payload.elements[element].subtitle){
                            gallery.subtitle = card.message.attachment.payload.elements[element].subtitle
                        }
                        else{
                            gallery.subtitle = null
                        }
                        if(card.imageaction[element] == true){
                        gallery.default_action = {"type":card.message.attachment.payload.elements[element].default_action.type,
                                                                    "url":card.message.attachment.payload.elements[element].default_action.url,
                                                                    "webview_height_ratio":card.message.attachment.payload.elements[element].default_action.webview_height_ratio
                                                                    } 
                        }
                        else{
                            gallery.default_action = {"type":"web_url",
                                                        "url":null,
                                                        "webview_height_ratio":"tall"
                                                    } 
                        }
                        
                        for (let button = 0; button < 3; button++){
                            let btn = {}
                            let labelname 
                            if(button == 0){
                            labelname = "First Button"
                            }
                            else if(button == 1){
                            labelname = "Second Button"
                            }
                            else if(button == 2){
                            labelname = "Third Button"
                            }
                            if(card.message.attachment.payload.elements[element].buttons[button] != undefined || card.message.attachment.payload.elements[element].buttons[button] != null){ 
                                btn.label = labelname 
                                btn.active = true 
                                btn.type =  card.message.attachment.payload.elements[element].buttons[button].type
                                if(card.message.attachment.payload.elements[element].buttons[button].type == 'postback'){
                                    console.log(card.message.attachment.payload.elements[element].buttons[button].payload)
                                    let obj = this.$store.state.responses
                                    let respname
                                    Object.keys(obj).forEach(function(key) {
                                    if (obj[key].id == card.message.attachment.payload.elements[element].buttons[button].payload) {
                                        respname = obj[key].name
                                    }
                                    });
                                    btn.title = card.message.attachment.payload.elements[element].buttons[button].title
                                    btn.response = {"name":respname,"id":card.message.attachment.payload.elements[element].buttons[button].payload}
                                    btn.payload = null 
                                    btn.url = null 
                                    btn.webview_height_ratio = "tall"              
                                }
                                else if(card.message.attachment.payload.elements[element].buttons[button].type == 'phone_number'){
                                    btn.title = card.message.attachment.payload.elements[element].buttons[button].title
                                    btn.payload = card.message.attachment.payload.elements[element].buttons[button].payload
                                    btn.response = null 
                                    btn.url = null 
                                    btn.webview_height_ratio = "tall"   
                                }
                                else if(card.message.attachment.payload.elements[element].buttons[button].type == 'web_url'){
                                    btn.title = card.message.attachment.payload.elements[element].buttons[button].title
                                    btn.url = card.message.attachment.payload.elements[element].buttons[button].url
                                    btn.webview_height_ratio = card.message.attachment.payload.elements[element].buttons[button].webview_height_ratio
                                    btn.response = null 
                                    btn.payload = null
                                } 
                                else if(card.message.attachment.payload.elements[element].buttons[button].type == 'element_share'){
                                    btn.title = null
                                    btn.url = null
                                    btn.webview_height_ratio = "tall"
                                    btn.response = null 
                                    btn.payload = null
                                } 
                                gallery.buttons.push(btn)         
                            }
                            else{
                                gallery.buttons.push({"label":labelname,"active":false,"title":null,"type":null,"url":null,"webview_height_ratio":"tall","payload":null,"response":null})
                            }
                        }
                        if (element == 0){
                            gallery.image_aspect_ratio = card.message.attachment.payload.image_aspect_ratio
                        }
                        this.editgallery.push(gallery)
                    }
                    console.log(this.editgallery) 
            }
            else if(this.cardtype == 'edit-list')
            {
                // this.editlist = []
                // this.editlistbutton = {}
                // for(let element = 0; element < card.elementscount; element++)
                //     {   
                //         let list = {}
                //         list.buttons = []
                //         list.active = true
                //         list.file = null
                //         list.title = card.message.attachment.payload.elements[element].title
                //         list.image_url = card.message.attachment.payload.elements[element].image_url
                //         if(!card.message.attachment.payload.elements[element].subtitle){
                //             list.subtitle = card.message.attachment.payload.elements[element].subtitle
                //         }
                //         else{
                //             list.subtitle = null
                //         }
                //         if(card.imageaction[element] == true){
                //         list.default_action = {"type":card.message.attachment.payload.elements[element].default_action.type,
                //                                                     "url":card.message.attachment.payload.elements[element].default_action.url,
                //                                                     "webview_height_ratio":card.message.attachment.payload.elements[element].default_action.webview_height_ratio,
                //                                                     "messenger_extensions":card.message.attachment.payload.elements[element].default_action.messenger_extensions
                //                                                     } 
                //         }
                //         else{
                //             list.default_action = {"type":"web_url",
                //                                         "url":null,
                //                                         "webview_height_ratio":"tall",
                //                                         "messenger_extensions":false
                //                                     } 
                //         }
                        
                //             let btn = {}
                //             let bottombtn = {}
                //             let button = 0
                //             if(card.message.attachment.payload.elements[element].buttons){ 
                //                 btn.active = true 
                //                 btn.type =  card.message.attachment.payload.elements[element].buttons[button].type
                //                 if(card.message.attachment.payload.elements[element].buttons[button].type == 'postback'){
                //                     console.log(card.message.attachment.payload.elements[element].buttons[button].payload)
                //                     let obj = this.$store.state.responses
                //                     let respname
                //                     Object.keys(obj).forEach(function(key) {
                //                     if (obj[key].id == card.message.attachment.payload.elements[element].buttons[button].payload) {
                //                         respname = obj[key].name
                //                     }
                //                     });
                //                     btn.title = card.message.attachment.payload.elements[element].buttons[button].title
                //                     btn.response = {"name":respname,"id":card.message.attachment.payload.elements[element].buttons[button].payload}
                //                     btn.payload = null 
                //                     btn.url = null 
                //                     btn.webview_height_ratio = "tall"              
                //                 }
                //                 else if(card.message.attachment.payload.elements[element].buttons[button].type == 'phone_number'){
                //                     btn.title = card.message.attachment.payload.elements[element].buttons[button].title
                //                     btn.payload = card.message.attachment.payload.elements[element].buttons[button].payload
                //                     btn.response = null 
                //                     btn.url = null 
                //                     btn.webview_height_ratio = "tall"   
                //                 }
                //                 else if(card.message.attachment.payload.elements[element].buttons[button].type == 'web_url'){
                //                     btn.title = card.message.attachment.payload.elements[element].buttons[button].title
                //                     btn.url = card.message.attachment.payload.elements[element].buttons[button].url
                //                     btn.webview_height_ratio = card.message.attachment.payload.elements[element].buttons[button].webview_height_ratio
                //                     btn.response = null 
                //                     btn.payload = null
                //                 } 
                //                 else if(card.message.attachment.payload.elements[element].buttons[button].type == 'element_share'){
                //                     btn.title = null
                //                     btn.url = null
                //                     btn.webview_height_ratio = "tall"
                //                     btn.response = null 
                //                     btn.payload = null
                //                 } 
                //                 list.buttons = btn         
                //             }
                //             else{
                //                 list.buttons = {"active":false,"title":"","type":null,"url":null,"webview_height_ratio":"tall","payload":null,"response":null}
                //             }
                //             //bottom button
                //             if(card.message.attachment.payload.elements[element].buttons){ 
                //                 bottombtn.active = true 
                //                 bottombtn.type =  card.message.attachment.payload.elements[element].buttons[button].type
                //                 if(card.message.attachment.payload.elements[element].buttons[button].type == 'postback'){
                //                     console.log(card.message.attachment.payload.elements[element].buttons[button].payload)
                //                     let obj = this.$store.state.responses
                //                     let respname
                //                     Object.keys(obj).forEach(function(key) {
                //                     if (obj[key].id == card.message.attachment.payload.elements[element].buttons[button].payload) {
                //                         respname = obj[key].name
                //                     }
                //                     });
                //                     bottombtn.title = card.message.attachment.payload.elements[element].buttons[button].title
                //                     bottombtn.response = {"name":respname,"id":card.message.attachment.payload.elements[element].buttons[button].payload}
                //                     bottombtn.payload = null 
                //                     bottombtn.url = null 
                //                     bottombtn.webview_height_ratio = "tall"              
                //                 }
                //                 else if(card.message.attachment.payload.elements[element].buttons[button].type == 'phone_number'){
                //                     bottombtn.title = card.message.attachment.payload.elements[element].buttons[button].title
                //                     bottombtn.payload = card.message.attachment.payload.elements[element].buttons[button].payload
                //                     bottombtn.response = null 
                //                     bottombtn.url = null 
                //                     bottombtn.webview_height_ratio = "tall"   
                //                 }
                //                 else if(card.message.attachment.payload.elements[element].buttons[button].type == 'web_url'){
                //                     bottombtn.title = card.message.attachment.payload.elements[element].buttons[button].title
                //                     bottombtn.url = card.message.attachment.payload.elements[element].buttons[button].url
                //                     bottombtn.webview_height_ratio = card.message.attachment.payload.elements[element].buttons[button].webview_height_ratio
                //                     bottombtn.response = null 
                //                     bottombtn.payload = null
                //                 } 
                //                 else if(card.message.attachment.payload.elements[element].buttons[button].type == 'element_share'){
                //                     bottombtn.title = null
                //                     bottombtn.url = null
                //                     bottombtn.webview_height_ratio = "tall"
                //                     bottombtn.response = null 
                //                     bottombtn.payload = null
                //                 } 
                //                 this.editlistbutton = btn         
                //             }
                //             else{
                //                 this.editlistbutton = {"active":false,"title":"","type":null,"url":null,"webview_height_ratio":"tall","payload":null,"response":null}
                //             }
                //         this.editlist.push(list)
                //     }                
            }
            else if(this.cardtype == 'edit-quickreply')
            {
                
            }
            else if(this.cardtype == 'edit-integration')
            {
                this.editintegrations = {}
                console.log(card)
                this.editintegrations.integrationType = card.integration_details.integration_type
                this.editintegrations.integrationTypeChoice = card.integration_details.integration_type_choice
                this.editintegrations.shortNote = card.integration_details.short_note
                if(card.integration_details.integration_type == 'Email')
                {
                   this.editintegrations.emailFrom = card.integration_details.email.from
                   this.editintegrations.emailTo = card.integration_details.email.to
                   this.editintegrations.emailSubject = card.integration_details.email.subject
                   this.editintegrations.emailBody = card.integration_details.email.body
                   this.editintegrations.emailBodyHtml = card.integration_details.email.body_html

                   this.editintegrations.gsheetName = null
                   this.editintegrations.gsheetcolumns = null 
                }
                else if (card.integration_details.integration_type == 'Google Sheets')
                {
                   this.editintegrations.gsheetName = card.integration_details.gsheets.name
                   this.editintegrations.gsheetId = card.integration_details.gsheets.sheetId
                   this.editintegrations.gsheetcolumns = card.integration_details.gsheets.columnValues   
                   
                   this.editintegrations.emailFrom = null
                   this.editintegrations.emailTo = null
                   this.editintegrations.emailSubject = null
                   this.editintegrations.emailBody = null
                   this.editintegrations.emailBodyHtml = null
                }
                console.log(this.editintegrations)

            }
            
            let status = true
            this.$store.dispatch('aresponsemenuStatusChange',status)
        },       
        expandTemplate(index){            
            this.$store.dispatch('aresponseIndexChange',{index})
        },
        editTemplateName(index,event,type){            
            this.$store.dispatch('aresponseIndexChange',{index})
            event.preventDefault()
            this.x = event.clientX
            this.y = event.clientY
            this.cardtype = type
            let status = true
            this.$store.dispatch('aresponsemenuStatusChange',status)
        },
        deleteTemplate(index){            
            this.$store.dispatch('aresponsedelete',{index})
        },
        openmenu(index){
            this.hover1 = index
        },
        closemenu(){
            this.hover1 = null
        },
        showbuttons(index){
            this.button1 = index
        },
        hidebuttons(){
            this.button1 = null
        },
        moveright(index){
            if(this.cards[index].currentelement != this.cards[index].elementscount - 1)
            {
            this.cards[index].currentelement = this.cards[index].currentelement + 1
            }
        },
        moveleft(index){
            if(this.cards[index].currentelement != 0)
            {
            this.cards[index].currentelement = this.cards[index].currentelement - 1
            }
        },
        moveup(index){
            this.$store.dispatch('aupmoveresponseMessage', {index})
        },
        movedown(index){
            this.$store.dispatch('adownmoveresponseMessage', {index})
        },
        deleteCard(index){
            this.$store.dispatch('aupdateresponseMessage', {index})
        },
        addDelay(type){
        this.cardtype = type
        let index = this.$store.state.currentResponseIndex
        let message = {"delay":this.delay,"type":"delay"}   
        this.$store.dispatch('acreateresponseMessage', {index,message})
        let status = false
        this.$store.dispatch('aresponsemenuStatusChange',status)
        },
        updateDelay(index,value){
            console.log(value)
            this.$store.dispatch('aupdateMessageDelay', {index,value})
        },
        showqrbuttons(qrindex){
           this.quickreplyindex = qrindex 
        },
        hideqrbuttons(){
            this.quickreplyindex = null
        },
        editquickreply(event,qrindex){
            this.editqreply = {}
            console.log(this.editqreply)
            let qreply = this.cquickreplies[qrindex]
            if(qreply.content_type == 'user_phone_number')
            {
                this.editqreply = {"qrindex":qrindex,"replytype":"user_phone_number", "title":null, "response":null}  
            }
            else if (qreply.content_type == 'user_email')
            {
                this.editqreply = {"qrindex":qrindex,"replytype":"user_email", "title":null, "response":null}
            }
            else if (qreply.content_type == 'location')
            {
                this.editqreply = {"qrindex":qrindex,"replytype":"location", "title":null, "response":null}
            }
            else if(qreply.content_type == 'text')
            {
                let obj = this.$store.state.responses
                let respname
                Object.keys(obj).forEach(function(key) {
                if (obj[key].id == qreply.payload) {
                    respname = obj[key].name
                }
                });
                this.editqreply =  {"qrindex":qrindex,"replytype":"text", "title":qreply.title, "response":respname}
            }
            event.preventDefault()
            this.x = event.clientX
            this.y = event.clientY
            this.cardtype = 'edit-'+'quickreply'
            console.log(this.cardtype)
            let status = true
            this.$store.dispatch('aresponsemenuStatusChange',status)
        },
        deletequickreply(qrindex){
             this.$store.dispatch('adeletequickreply',{qrindex})
        }        
    },
    computed:{
        cMessages(){
            console.log(this.$store.state.responses)
            if(this.$store.state.responses.length > 0)
            {
                return this.$store.state.responses
            }
            else {
                return []
            }
            
        },
        bcastmenu(){
            return this.$store.state.responseMenuStatus
        },
        cards(){
            if(this.$store.state.currentResponseIndex != null)
            {   
                let index = this.$store.state.currentResponseIndex
                let cards = this.$store.state.responses[index].messages
                this.cardId = this.$store.state.responses[index].id
                 console.log(cards)
                return cards
            }
            else {
                return []
            }
        },
        cquickreplies(){
            if(this.$store.state.currentResponseIndex != null)
            {                
            let index = this.$store.state.currentResponseIndex
            if(this.$store.state.responses[index].quickreplies.qreplies.length > 0)
            {
            return this.$store.state.responses[index].quickreplies.qreplies
            }
            else{
                return []
            }
            }
        },
        templateIndex(){
            return this.$store.state.currentResponseIndex 
        },
        refid(){
            if(this.$store.state.pageDetails.username == undefined){
                this.boturl = "https://m.me/"+this.$store.state.pageDetails.page_id
               return this.$store.state.pageDetails.page_id
            }
            else{
                this.boturl = "https://m.me/"+this.$store.state.pageDetails.username
                return this.$store.state.pageDetails.username
            }
        }
    },
    created(){
       
    }
    
}
</script>


<style scoped>
*{ text-transform: none !important; }
</style>

